import React from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import {useComboValues} from "../services/settings";
import StringToJsx from "../functions/StringToJsx";

const ComboTemplate = (props) => {

  const queryClient = useQueryClient();
  const extraKeys = __.pick(props, ['group', 'subGroup']);
  const fieldData = props.data;

  const comboValues = useComboValues({queryClient, extraKeys: Object.values(extraKeys), useCache: true});

  let response = null;
  if (comboValues && comboValues.data) {
    let option = __.find(comboValues.data, {code: props.code||props.value});
    if (option){
      let htmlResponse = option.data?.template||option.value;
      if (typeof fieldData === "object" && Object.keys(fieldData)) {
        Object.entries(fieldData).forEach(([fieldName, value]) => {
          htmlResponse = __.replace(htmlResponse,new RegExp(`{${fieldName}}`,"g"),value);
        });
      }
      if (htmlResponse) {
        response = <StringToJsx domString={htmlResponse}/>;
        // if (!response || (Array.isArray(response) && response[0] === 'undefined')) {
        //   response = <StringToJsx domString={`<span>${htmlResponse}</span>`}/>;
        // }
      }
    }
  }
  if (!response) {
    return null;
  }
  return response;
}

export default ComboTemplate;